<template>
	<section class="activity-detail-section">
		<h3>{{ title }}</h3>
		<slot></slot>
	</section>
</template>

<script setup lang="ts">
defineProps<{
	title: string
}>()
</script>

<style scoped>
.activity-detail-section {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-sm);

	h3 {
		margin: 0;
		color: var(--neutral-400);
		font-size: var(--font-size-xs);
		font-weight: var(--font-weight-semibold);
		letter-spacing: 0.02em;
		line-height: var(--line-height-tight);
		text-transform: uppercase;
	}
}
</style>
